import { parse, valid } from 'node-html-parser'
import { h } from 'vue'
import defu from 'defu'

const isHtmlElement = (val: any): val is HTMLElement => val && val?.tagName

export default defineComponent({
  name: 'Wysiwyg',
  props: {
    markup: {
      type: String,
    },
  },
  setup({ markup }) {
    // bail when empty
    if (!markup) return () => null
    if (!valid(markup)) return () => null

    const _attrs = useAttrs()
    const defaults = {
      class: ['wysiwyg', 'prose'],
    }

    const root = parse(markup)?.removeWhitespace()
    const mains = root.getElementsByTagName('main')
    const main = mains.pop()?.removeWhitespace()

    const attrs = defu(defaults, _attrs)

    if (!main) {
      return () =>
        h('div', {
          ...attrs,
          innerHTML: markup,
        })
    }

    // return render function
    return () => {
      // replace promotion placeholders with promos
      const children = main.childNodes
        .filter((ele) => {
          if (!isHtmlElement(ele)) return false
          if (ele.classList.contains('wp-block-audio')) return false
          return true
        })
        .map((ele) => {
          if (!isHtmlElement(ele)) return () => null

          const tag = ele.tagName
          const attributes = ele.attributes || {}

          // @ts-ignore
          return h(tag, {
            ...attributes,
            innerHTML: ele.innerHTML,
          })
        })

      // @ts-ignore
      return h('div', attrs, children)
    }
  },
})
